import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';

interface CsrfTokenState {
    csrfToken: string;
}

const initialState: CsrfTokenState = {
    csrfToken: ''
};

const csrfTokenSliceOptions = {
    name: 'csrfToken',
    initialState,
    reducers: {
        /**
         * Update the csrf token. This action should not be used to "clear" the csrfToken, only to update it with a new
         * token
         */
        updateCsrfToken: (state, action: PayloadAction<CsrfTokenState>) => {
            if (action.payload.csrfToken) {
                state.csrfToken = action.payload.csrfToken;
            } else {
                console.warn('updateCsrfToken: Tried to update with an empty csrf token, this will not work');
            }
        }
    }
};

/**
 * A Redux-toolkit slice for csrf token
 *
 * Store the csrf token for api calls
 *
 * @deprecated It's not a good idea to use this slice directly in your project as you cannot customise it
 * and this will almost certainly cause issues.
 *
 * Use the createCsrfTokenSlice factory function defined below instead.
 */
export const csrfTokenSlice = createSlice(csrfTokenSliceOptions);

/**
 * Factory function to create a csrfToken slice.
 *
 * @param options {object} options for the slice which will override the default slice options.
 */
export const createCsrfTokenSlice = (options = {}) => {
    return createSlice({
        ...csrfTokenSliceOptions,
        ...options
    });
};

export const csrfTokenActions = csrfTokenSlice.actions;

const getCsrfToken = rootState => rootState.csrfToken || initialState;
export const selectCsrfToken = createSelector(getCsrfToken, state => state.csrfToken);
